import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// initial state
const state = {
  loadingNum: 0 // room information
};

// mutations
const mutations = {
  setLoading(state, num) {
    state.loadingNum += num;

    if (state.loadingNum < 0) {
      state.loadingNum = 0;
    }
  }
};

// actions
const actions = {
  show(context, num) {
    context.commit("setLoading", num);
  },
  hide(context, num) {
    context.commit("setLoading", num * -1);
  }
};

// getters
const getters = {
  getLoading: function (state) {
    return state.loading;
  }
};

export default {
  // 名前空間を使うように
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
